import { FC } from 'react';
import { Image, Loader } from '@storybook';
import { DropOption } from 'components';

import {
	EmailClientMethod,
	EmailClientMethodIcon,
} from 'views/email-client/constants';
import { EmailClientActionLoadingState, IClientEmail } from 'views/email-client/stores';
import { useRecoilValue } from 'recoil';

interface ClientItemProps {
	client: IClientEmail;
	showDropdown?: boolean;
	dropOptions?: any[];
	onClick?: () => void;
	className?: string;
}

export const ClientItem: FC<ClientItemProps> = ({
	client,
	showDropdown = false,
	dropOptions = [],
	onClick,
	className = '',
}) => {
	const emailClientActionLoading = useRecoilValue(EmailClientActionLoadingState);
	return (
		<div
			className={`connected-client_wrapper ${className}`}
			onClick={onClick}
		>
			<div className="connected-client_header">
				<div className="connected-client_header-wrapper">
					<div className="connected-client_logo">
						<Image
							fileName={
								EmailClientMethodIcon[
									client?.provider as keyof typeof EmailClientMethodIcon
								]
							}
						/>
					</div>
					<div className="connected-client_info-content">
						<div className="connected-client_title">
							{client?.config?.email}
							{client?.isActive && (
								<span className="connected-client_is-default">
									Default
								</span>
							)}
						</div>
						<div className="connected-client_subtitle">
							{
								EmailClientMethod[
									client?.provider as keyof typeof EmailClientMethod
								]
							}
						</div>
					</div>
					{emailClientActionLoading[client._id] ? <Loader dimension={20} type="loader" /> : showDropdown && <DropOption options={dropOptions} />}
				</div>
			</div>
		</div>
	);
}; 